import React from "react";

// src/Footer.js
export default function Footer() {
  return (
    <footer>
      <div className="footer">
        <p
          style={{
            fontWeight: "normal",
            fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande','Lucida Sans', Arial, sans-serif"
          }}
        >
          &copy; účtovníctvo-poprad {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}